module.exports = __webpack_public_path__ + "static/media/International-Interpol-Cases.6585fe89.jpg";